const MODULE_NAME = "HELP";
const TOGGLE_HELP = MODULE_NAME + 'TOGGLE';
const FETCH_SECTION_STARTED = MODULE_NAME + 'FETCH_SECTION_STARTED';
const FETCH_SECTION_COMPLETED = MODULE_NAME + 'FETCH_SECTION_COMPLETED';
const FETCH_SECTION_FAILED = MODULE_NAME + 'FETCH_SECTION_FAILED';

export {
  TOGGLE_HELP,
  FETCH_SECTION_STARTED,
  FETCH_SECTION_COMPLETED,
  FETCH_SECTION_FAILED
};
